
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'CollapseButton',
    emits: ['click'],
    props: {
      isShow: {
        type: Boolean,
        required: true,
      },
    },
    data(): {} {
      return {};
    },
    methods: {
      clickButton() {
        this.$emit('click');
      },
    },
  });
